module.exports = __webpack_public_path__ + "img/breadcrumb_triangle.3193df96.svg";